import { IQPointMapsApiKeyService } from '../../../projects/qpoint-maps/src/lib/services/google-api-key.service';

export class MapsApiKeyService implements IQPointMapsApiKeyService {

  constructor() {
  }

  getGoogleMapsApiKey(): Promise<string> {
    return Promise.resolve('AIzaSyB_uXvqpUtKZ9RhXeJaNz57a0KSbDvA2nA');
  }
}
